"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var unfetch_1 = tslib_1.__importDefault(require("unfetch"));
var fetch = unfetch_1.default;
if (typeof window !== 'undefined') {
    fetch = window.fetch || unfetch_1.default;
}
function default_1() {
    function dispatch(url, body) {
        return fetch(url, {
            headers: { 'Content-Type': 'text/plain' },
            method: 'post',
            body: JSON.stringify(body),
        });
    }
    return {
        dispatch: dispatch,
    };
}
exports.default = default_1;
//# sourceMappingURL=fetch-dispatcher.js.map